import { useState } from 'react';

import { CareerQuestion, CareerUserResponseSet } from '@backrs_ui/grow-ui/src/models/models';
import { useAspirationCategories } from '@backrs_ui/grow-ui/src/pages/Result/hooks/useAspirationCategories';

import { Box, SxProps, Theme } from '@mui/material';

import { AspirationCategoryItem } from './AspirationCategoryItem';

type AspirationAccordionProps = Readonly<{
  draftResponseSet: CareerUserResponseSet;
  careerQuestions: CareerQuestion[];
  onAnswerChange: (questionId: number, optionIds: number[]) => void;
  registerCategoryRef?: (key: string, el: HTMLElement | null) => void;
  onCategoryHeaderHover?: (key: string | null) => void;
}>;

export function AspirationAccordion({
  draftResponseSet,
  careerQuestions,
  onAnswerChange,
  registerCategoryRef,
  onCategoryHeaderHover,
}: AspirationAccordionProps) {
  const categories = useAspirationCategories(careerQuestions);
  const [expandedKey, setExpandedKey] = useState<string | null>(null);

  const handleToggle = (key: string) => {
    setExpandedKey((prev) => (prev === key ? null : key));
  };

  return (
    <Box sx={containerSx}>
      {categories.map((category) => (
        <AspirationCategoryItem
          key={category.key}
          category={category}
          isExpanded={expandedKey === category.key}
          onToggle={() => handleToggle(category.key)}
          draftResponseSet={draftResponseSet}
          careerQuestions={careerQuestions}
          onAnswerChange={onAnswerChange}
          registerRef={registerCategoryRef}
          onHeaderHoverChange={onCategoryHeaderHover}
        />
      ))}
    </Box>
  );
}

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-md'],
});
